import * as React from 'react';
import { useStores } from 'utility/hooks';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { GlassboxScript } from 'components/glassbox/glassbox-script';

export const GlassboxWrapper = () => {
  const { context } = useStores();

  return (
    context.site.optInPrivacyInfo.canTrack && (
      <Experiment name="Flights_PWA_Glassbox">
        <ExperimentControl />
        <ExperimentVariant bucket={1}>
          <GlassboxScript />
        </ExperimentVariant>
      </Experiment>
    )
  );
};
